<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div id="loi-selection">
  <div class="loi-container">
    <div class="loi-panel">
      <div *ngIf="lois.size === 0" class="no-lois-image-container">
        <img src="assets/img/forest.svg" />
        <p i18n="@@app.labels.noLocationsImported">No locations imported</p>
      </div>

      <mat-list class="loi-list">
        <mat-list-item *ngFor="let loi of lois">
          <div class="loi-list-item">
            <mat-icon svgIcon={{getLoiIcon(loi)}} [ngStyle]="{ color: job?.color }"></mat-icon>

            {{ getDisplayName(loi) }}
          </div>
        </mat-list-item>
      </mat-list>
    </div>

    <div class="loi-map">
      <ground-map [showPredefinedLoisOnly]="true" [selectedJob]="job"></ground-map>
    </div>
  </div>
</div>
